export const A11Y_TITLE = 'Spotify Player';
export const TRANSLATION_FEATURE = 'AriaLabels';
export const TRANSLATION_KEY = 'SpotifyPlayer_AriaLabel_TopLevel';
